webpackJsonp([12],{

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kuldottek_listaja_pug__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kuldottek_listaja_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__kuldottek_listaja_pug__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var MODULE_NAME = 'kuldottekListaja';

var KuldottekListajaController = function () {
	function KuldottekListajaController() {
		'ngInject';

		_classCallCheck(this, KuldottekListajaController);
	}

	KuldottekListajaController.prototype.$onInit = function $onInit() {
		this.kuldottekListajaTitle = window.kuldottekListajaTitle;
		this.kuldottekListajaLabel = window.kuldottekListajaLabel;
		this.kuldottekListaja = window.kuldottekListaja;
		this.selectedYear = Object.keys(this.kuldottekListaja)[0];
	};

	return KuldottekListajaController;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (angular.module(MODULE_NAME, []).component(MODULE_NAME, {
	controller: KuldottekListajaController,
	template: __WEBPACK_IMPORTED_MODULE_0__kuldottek_listaja_pug___default()(),
	bindings: {}
}).name);

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kuldottek_listaja_kuldottek_listaja_pcss__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kuldottek_listaja_kuldottek_listaja_pcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__kuldottek_listaja_kuldottek_listaja_pcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kuldottek_listaja_kuldottek_listaja_js__ = __webpack_require__(302);



/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"app-kuldottek-listaja\"\u003E\u003Ch5 class=\"app-kuldottek-listaja__title\"\u003E{{$ctrl.kuldottekListajaTitle}}\u003C\u002Fh5\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"app-kuldottek-listaja__label-container\"\u003E\u003Clabel class=\"label label--right label--two-lines\" id=\"kuldottek-listaja__ev-label\" for=\"kuldottek-listaja__ev\"\u003E{{$ctrl.kuldottekListajaLabel}}:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"app-kuldottek-listaja__select-container\"\u003E\u003Cdiv class=\"app-kuldottek-listaja__select-support\"\u003E\u003Cselect class=\"select\" id=\"kuldottek-listaja__ev\" name=\"ev\" ng-options=\"item.documentName for item in $ctrl.kuldottekListaja\" ng-model=\"$ctrl.oiSelectModel\"\u003E\u003Coption value=\"\" disabled selected\u003EKérjük válasszon!\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"button\" ng-show=\"$ctrl.oiSelectModel.documentLink\" href=\"{{$ctrl.oiSelectModel.documentLink}}\" target=\"_blank\" rel=\"noopener noreferrer\" role=\"button\"\u003ELetöltés\u003Cspan class=\"sr-only\"\u003E. {{row.documentExtension}} dokumentum letöltése.\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ })

},[552]);


// WEBPACK FOOTER //
// application/kuldottek-listaja.bundle.js